// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"28":"666a505e64c4eaf92a6b","491":"7414308427e9b158f776","549":"0d6e01bc30fa330b5466"}[chunkId] + ".css";
};